var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import WidgetWrapper from '@widget/other/WidgetWrapper';
import { useSearchParams } from '@hooks/useRouteHandlers';
const DiagnosticWidget = (props) => {
    const { uxpContext } = props, rest = __rest(props, ["uxpContext"]);
    const searchParams = useSearchParams();
    const propEntries = Object.entries(rest);
    const paramEntries = Object.entries(searchParams || {});
    function renderValue(value) {
        if (value === null || value === undefined)
            return String(value);
        if (typeof value === 'object')
            return JSON.stringify(value, null, 2);
        return String(value);
    }
    function renderTable(entries) {
        return (_jsxs("table", { className: "uxpcore_diagwidget__table", children: [_jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", { children: "Key" }), _jsx("th", { children: "Value" })] }) }), _jsx("tbody", { children: entries.map(([key, value]) => (_jsxs("tr", { children: [_jsx("td", { className: "uxpcore_diagwidget__key", children: key }), _jsx("td", { className: "uxpcore_diagwidget__value", children: renderValue(value) })] }, key))) })] }));
    }
    return (_jsx(WidgetWrapper, { children: _jsxs("div", { className: "uxpcore_diagwidget__container", children: [_jsxs("section", { className: "uxpcore_diagwidget__section", children: [_jsx("h3", { className: "uxpcore_diagwidget__heading", children: "Props" }), propEntries.length === 0
                            ? _jsx("p", { className: "uxpcore_diagwidget__empty", children: "No props received" })
                            : renderTable(propEntries)] }), _jsxs("section", { className: "uxpcore_diagwidget__section", children: [_jsx("h3", { className: "uxpcore_diagwidget__heading", children: "Search Params" }), paramEntries.length === 0
                            ? _jsx("p", { className: "uxpcore_diagwidget__empty", children: "No search params" })
                            : renderTable(paramEntries)] })] }) }));
};
export default DiagnosticWidget;
